import { Injectable } from '@angular/core';
declare var jquery: any;
declare var $: any;

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class SearchTypeService {
  constructor() {
  }

  SearchTypeButtons() {
    $('.search-type label.active input[type="radio"]').prop('checked', true);
    var buttonWidth = $('.search-type label.active').width();
    var arrowDist = $('.search-type label.active').position().left;
    $('.search-type-arrow').css('left', arrowDist + (buttonWidth / 2));
    $('.search-type label').on('change', function () {
      $('.search-type input[type="radio"]').parent('label').removeClass('active');
      $('.search-type input[type="radio"]:checked').parent('label').addClass('active');
      var buttonWidth = $('.search-type label.active').width();
      var arrowDist = $('.search-type label.active').position().left;
      $('.search-type-arrow').css({ 'left': arrowDist + (buttonWidth / 2), 'transition': 'left 0.4s cubic-bezier(.87,-.41,.19,1.44)' });
    });
  }


  MoreSearchOptions() {
    $('.more-search-options-trigger').on('click', function (e) {
      e.preventDefault();
      $('.more-search-options, .more-search-options-trigger').toggleClass('active');
      $('.more-search-options.relative').animate({
        height: 'toggle',
        opacity: 'toggle'
      }, 300);
    });
  }

  Render() {
    setTimeout(() => { // fat arrow
      if ($(".main-search-form").length) {
        this.SearchTypeButtons();
        this.MoreSearchOptions();
      }
    }, 500);
  }
}
